/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import Vue from 'vue';
import Router from 'vue-router';
import {
  Campaigns,
  Home,
  PlansList,
  Profile,
  Subscribe,
  Users,
  Settings,
  NewCampaign,
  SignUp,
  Billing,
  Goals,
  Accounts,
  AdminAccountDashboard,
  AdminAccountUsers,
  FacebookOauth,
  Onboarding,
  Dashboard,
  Analytics,
  Tasks
} from '@/components';
// import {AmplifyEventBus, AmplifyPlugin, components} from 'aws-amplify-vue';
import '@aws-amplify/ui-vue';
import Amplify, { Auth } from 'aws-amplify';
import AmplifyStore from '../store/store';

Vue.use(Router);
// Vue.use(AmplifyPlugin, AmplifyModules);

let user;
let subscribed = null;

// getUser().then((user, error) => {
//   if (user) {
//     // AmplifyEventBus.$emit("authState", "authenticated")
//     router.push({path: '/'})
//   }
// })

// AmplifyEventBus.$on('authState', async (state) => {
//   if (state === 'signedOut') {
//     user = null;
//     AmplifyStore.commit('setUser', null);
//     router.push({path: '/auth'})
//   } else if (state === 'signedIn') {
//     user = getUser();
//     router.push({path: '/'})
//   }
// });

function getUser() {
  
  let user = Auth.currentAuthenticatedUser().then(data => {
    AmplifyStore.commit('setUser', data)
    return data
  }).catch(e => {
    AmplifyStore.commit('setUser', null)
    return e
  })
  // return .then((data) => {
  //   if (data && data.signInUserSession) {
  //     console.log("Auth token:")
  //     console.log(data);
  //     AmplifyStore.commit('setUser', data);
  //     return data;
  //   }
  // }).catch((e) => {
  //   AmplifyStore.commit('setUser', null);
  //   return null
  // });
}

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/analytics',
      name: 'Analytics',
      component: Analytics,
      meta: {requiresAuth: true}
    },
    {
      path: '/admin/tasks',
      name: 'Tasks',
      component: Tasks,
      meta: {requiresAuth: true}
    },
    {
      path: '/accounts/:id',
      name: 'Dashboard',
      component: Dashboard,
      meta: {requiresAuth: true}
    },
    {
      path: '/accounts/:id/users',
      name: 'Users',
      component: Users,
      params: {},
      meta: {requiresAuth: true}
    },
    {
      path: '/goals',
      name: 'Goals',
      component: Goals,
      params: {},
      meta: {requiresAuth: true}
    },
    {
      path: '/campaigns',
      name: 'Campaigns',
      component: Campaigns,
      params: {},
      meta: {requiresAuth: true}
    },
    {
      path: '/campaigns/new',
      name: 'NewCampaign',
      component: NewCampaign,
      params: {},
      meta: {requiresAuth: true}
    },
    {
      path: '/plans',
      name: 'Plans',
      component: PlansList,
      meta: {requiresAuth: true}
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {requiresAuth: true}
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/subscribe',
      name: 'Subscribe',
      component: Subscribe,
      meta: {requiresAuth: true}
    },
    {
      path: '/settings',
      name: 'Settings', 
      component: Settings, 
      meta: { requiresAuth: true }
    },
    {
      path: '/billing',
      name: 'Billing', 
      component: Billing, 
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      name: 'Accounts', 
      component: Accounts, 
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/:id/dashboard',
      name: 'AdminAccountDashboard', 
      component: AdminAccountDashboard, 
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/:id/users',
      name: 'AdminAccountUsers', 
      component: AdminAccountUsers, 
      meta: { requiresAuth: true }
    },
    {
      path: '/accounts/:id/oauth/facebook',
      name: 'FacebookOauth',
      component: FacebookOauth,
      meta: { requiresAuth: true }
    },
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: Onboarding,
      meta: { requiresAuth: true }
    }
  ]
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js